import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 840AF950-F514-452B-AD1F-18EC878CB1F8
 * name pipe
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pipe.svg
 * tags
 * - Home Automation 
 */
export const PipeIcon = createSvgIcon(<><path d="M22,14H20V16H14V13H16V11H14V6A2,2 0 0,0 12,4H4V2H2V10H4V8H10V11H8V13H10V18A2,2 0 0,0 12,20H20V22H22" /></>, 'PipeIcon');
export default PipeIcon